import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon, obj = user

  const bootstrap = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password, login_type) => {
    const body = { email, password };
    if (login_type) body.login_type = login_type;
    const { data } = await api.post("/auth/login", body);
    if (data.access_token) setToken(data.access_token);
    setUser({
      id: data.id,
      email: data.email,
      name: data.name,
      role: data.role,
      login_type: data.login_type,
      is_super_admin: data.is_super_admin,
      personnel_id: data.personnel_id,
      artist_id: data.artist_id,
      branch_id: data.branch_id,
    });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) { /* ignore */ }
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
